import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Form,
  Label,
  Row,
} from 'reactstrap'
// import moment from 'moment'
import { Fragment, useCallback, useEffect, useRef, useState } from 'react'
import Select from 'react-select'
import { Controller, useForm } from 'react-hook-form'
import SchemaValidations from './validations'
import ResponsiveDatePickers from '../../../components/date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { getExcelReports, getExcelReportsFile } from '../store'
import toast from 'react-hot-toast'

const stateOptions = [
  { value: 'todos', label: 'Todos' },
  { value: 'exitosos', label: 'Exitosos' },
  { value: 'error', label: 'Error' },
]

const initialFilterProps = {
  state: stateOptions[0],
  startDate: null,
  endDate: null,
}

export function ReportsFilters() {
  const dispatch = useDispatch()
  const { currentPage, data, isPending } = useSelector(
    (state) => state.excelReports
  )

  const abortControllerRef = useRef(null)
  const [filterProps, setFilterProps] = useState(initialFilterProps)

  const {
    handleSubmit,
    control,
    reset,
    // formState: { errors },
  } = useForm({
    defaultValues: {
      ...initialFilterProps,
    },
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(SchemaValidations),
  })

  useEffect(() => {
    getData()

    return () => {
      abortControllerRef.current?.abort()
    }
  }, [currentPage])

  const getData = () => {
    const startDate = filterProps.startDate?.format('YYYY-MM-DD') ?? null
    const endDate = filterProps.endDate?.format('YYYY-MM-DD') ?? null

    if (startDate && endDate && filterProps.state) {
      if (abortControllerRef.current) {
        abortControllerRef.current?.abort() // Cancelar petición anterior si existe
      }

      abortControllerRef.current = new AbortController()

      dispatch(
        getExcelReports({
          filters: {
            fechaDesde: startDate,
            fechaHasta: endDate,
            estadoDocumentos: filterProps.state.value,
          },
          page: currentPage,
          signal: abortControllerRef.current.signal,
        })
      )
    }
  }
  const getFile = () => {
    const startDate = filterProps.startDate?.format('YYYY-MM-DD') ?? null
    const endDate = filterProps.endDate?.format('YYYY-MM-DD') ?? null

    if (startDate && endDate && filterProps.state) {
      dispatch(
        getExcelReportsFile({
          filters: {
            fechaDesde: startDate,
            fechaHasta: endDate,
            estadoDocumentos: filterProps.state.value,
          },
        })
      ).then((response) => {
        if (response.error) {
          return toast.error('Error al descargar el archivo')
        }

        const binaryString = atob(response.payload.data)

        const len = binaryString.length
        const bytes = new Uint8Array(len)

        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i)
        }

        const url = window.URL.createObjectURL(
          new Blob([bytes], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
        )
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', response.payload.fileName)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
      })
    }
  }

  const handleClearFilters = () => {
    setFilterProps(initialFilterProps)
    reset()
  }

  const onSubmit = useCallback(() => {
    getData()
  }, [filterProps])

  return (
    <Fragment>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Card>
          <CardHeader className="flex-md-row flex-column align-md-items-center align-items-start border-bottom">
            <CardTitle tag="h4">Documentos Emitidos</CardTitle>
          </CardHeader>
          <Row
            className="mx-0"
            style={{ marginBlock: '1%', paddingLeft: '5%' }}
          >
            <Col
              md="3"
              sm="12"
            >
              <Label className="me-1">Estado de documentos</Label>
              <Controller
                name="state"
                control={control}
                render={() => (
                  <Select
                    options={stateOptions}
                    value={filterProps.state}
                    onChange={(item) => {
                      setFilterProps({ ...filterProps, state: item })
                    }}
                  />
                )}
              />
            </Col>
          </Row>
          <Row
            className="mx-0"
            style={{ paddingLeft: '5%' }}
          >
            <Col
              md="5"
              sm="12"
            >
              <Label
                className="me-1"
                for="search-input"
              >
                Desde
              </Label>
              <div className="mb-50">
                <ResponsiveDatePickers
                  value={filterProps.startDate}
                  onChange={(date) =>
                    setFilterProps({ ...filterProps, startDate: date })
                  }
                  maxDate={filterProps.endDate}
                  Label=""
                  placeholder="Selecciona una fecha"
                  datePickerHeight="0px"
                />
              </div>
            </Col>

            <Col
              md="5"
              sm="12"
            >
              <Label
                className="me-1"
                for="search-input"
              >
                Hasta
              </Label>
              <div className="mb-50">
                <ResponsiveDatePickers
                  value={filterProps.endDate}
                  onChange={(value) =>
                    setFilterProps({ ...filterProps, endDate: value })
                  }
                  minDate={filterProps.startDate}
                  Label=""
                  placeholder="Selecciona una fecha"
                  datePickerHeight="0px"
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="d-flex align-items-center justify-content-sm-center mx-2 my-3">
              <Button
                className="mx-2"
                style={{ size: '10px', width: '200px' }}
                color="primary"
                type="submit"
                disabled={isPending}
              >
                Búsqueda
              </Button>
              <Button
                className="mx-2"
                style={{ size: '10px', width: '200px' }}
                color="primary"
                type="reset"
                onClick={handleClearFilters}
                disabled={isPending}
              >
                Limpiar Filtros
              </Button>
            </Col>
          </Row>
        </Card>
      </Form>

      {data.length > 0 && (
        <div className="d-flex justify-content-end mb-2 mx-2">
          <Button
            className=""
            style={{ size: '10px', width: '200px' }}
            color="primary"
            type="submit"
            onClick={getFile}
            disabled={isPending}
          >
            Descargar Reporte Excel
          </Button>
        </div>
      )}
    </Fragment>
  )
}
